import "./index.css";
import { useTranslation } from "react-i18next";
import { clsx } from "clsx";

type IProps = {
  text?: string;
  className?: string;
};

export const NotProvided = ({ text, className }: IProps) => {
  const { t } = useTranslation();

  return (
    <span className={clsx("not-provided-state", className)}>
      {text || t("label.not_provided")}
    </span>
  );
};
